import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { PRIVATE_PATHS } from 'utils/paths'
import NextStepsPanel from 'features/dashboard/sections/NextStepsPanel'

const COMPLIANCE_KEYS = ['needs_setup', 'compliance_expired', 'compliance_awaiting_review']

const GuidanceDrawer = ({ open, onClose, mode }) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!open) return undefined
    const onKey = e => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  const onStep = step => {
    onClose()
    if (COMPLIANCE_KEYS.includes(step.key)) {
      navigate(PRIVATE_PATHS.dashboard)
      return true
    }
    return false
  }

  return createPortal(
    <>
      <Overlay $open={open} onClick={onClose} aria-hidden='true' />
      <Drawer $open={open} role='dialog' aria-label='Your next steps' aria-hidden={!open}>
        <Head>
          <HeadTitle>Next steps</HeadTitle>
          <CloseBtn type='button' onClick={onClose} aria-label='Close'>
            <CloseRoundedIcon style={{ fontSize: 20 }} />
          </CloseBtn>
        </Head>
        <Body>
          {open && <NextStepsPanel mode={mode} onStep={onStep} />}
        </Body>
      </Drawer>
    </>,
    document.body
  )
}

export default GuidanceDrawer

const Overlay = styled.div`
  position: fixed; inset: 0; z-index: 3999;
  background: rgba(20, 26, 40, 0.32);
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
  transition: opacity 180ms ease;
`
const Drawer = styled.aside`
  position: fixed; top: 0; right: 0; bottom: 0; z-index: 4000;
  width: 440px; max-width: 92vw;
  background: #fff; border-left: 1px solid #e9ebf0;
  box-shadow: -8px 0 28px rgba(20, 30, 60, 0.10);
  display: flex; flex-direction: column;
  transform: translateX(${({ $open }) => ($open ? '0' : '100%')});
  transition: transform 220ms ease;
`
const Head = styled.div`
  flex: 0 0 auto; display: flex; align-items: center; justify-content: space-between;
  padding: 18px 20px; border-bottom: 1px solid #eef0f3;
`
const HeadTitle = styled.h2`font-size: 17px; font-weight: 800; color: #1b2233; margin: 0;`
const CloseBtn = styled.button`
  display: inline-flex; align-items: center; justify-content: center; width: 34px; height: 34px;
  border: none; border-radius: 8px; background: #f1f3f7; color: #4a4f5e; cursor: pointer;
  &:hover { background: #e8ebf0; }
`
const Body = styled.div`flex: 1 1 auto; overflow-y: auto; padding: 18px 20px;`
